import React, { useState } from 'react';
import { Tv, MessageCircle, Wifi, Heart, HelpCircle, Mic, Volume2 } from 'lucide-react';
const Help = () => {
  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const helpTopics = [{
    icon: <Tv className="w-7 h-7" data-id="element-367" />,
    text: 'How do I set up Netflix?',
    color: 'from-mint-green/20 to-mint-green/5'
  }, {
    icon: <MessageCircle className="w-7 h-7" data-id="element-368" />,
    text: 'What were the shows my friend mentioned?',
    color: 'from-lavender/20 to-lavender/5'
  }, {
    icon: <Wifi className="w-7 h-7" data-id="element-369" />,
    text: 'How do I reset the internet?',
    color: 'from-soft-coral/20 to-soft-coral/5'
  }, {
    icon: <Heart className="w-7 h-7" data-id="element-370" />,
    text: 'How can I send a message to my family?',
    color: 'from-mint-green/20 to-mint-green/5'
  }, {
    icon: <HelpCircle className="w-7 h-7" data-id="element-371" />,
    text: 'What should I do when I feel overwhelmed?',
    color: 'from-lavender/20 to-lavender/5'
  }];
  const handleTopicClick = (text: string) => {
    setIsSpeaking(true);
    // In a real app, this would trigger text-to-speech
    setTimeout(() => setIsSpeaking(false), 3000);
  };
  const handleVoiceInput = () => {
    setIsListening(true);
    // In a real app, this would activate voice recognition
    setTimeout(() => setIsListening(false), 3000);
  };
  return <div className="h-[calc(100vh-130px)] flex flex-col pt-4" data-id="element-372">
      {/* Header */}
      <div className="mb-6" data-id="element-373">
        <h1 className="text-2xl font-medium mb-2 dark:text-white flex items-center gap-2" data-id="element-374">
          <HelpCircle className="w-8 h-8 text-lavender" data-id="element-375" />
          Need Help?
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400" data-id="element-376">
          Tap a question below or just ask COMO
        </p>
      </div>
      {/* Help Topics */}
      <div className="flex-1 space-y-3" data-id="element-377">
        {helpTopics.map((topic, index) => <button key={index} onClick={() => handleTopicClick(topic.text)} className={`
              w-full p-4 rounded-2xl text-left transition-all duration-200
              bg-gradient-to-r ${topic.color}
              hover:scale-[1.02] active:scale-[0.98]
              border border-gray-100 dark:border-gray-800
              flex items-center gap-4
              group
              relative
            `} data-id="element-378">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-white dark:bg-slate-800 
              flex items-center justify-center text-lavender" data-id="element-379">
              {topic.icon}
            </div>
            <span className="text-lg font-medium text-gray-700 dark:text-gray-200" data-id="element-380">
              {topic.text}
            </span>
            <Volume2 className={`
                absolute right-4 w-6 h-6 
                text-gray-400 dark:text-gray-500
                opacity-0 group-hover:opacity-100 
                transition-opacity duration-200
              `} data-id="element-381" />
          </button>)}
      </div>
      {/* Voice Input */}
      <div className="mt-6 flex justify-center" data-id="element-382">
        <button onClick={handleVoiceInput} className={`
            p-6 rounded-full transition-all duration-300
            ${isListening ? 'bg-soft-coral text-white animate-pulse' : 'bg-lavender/10 hover:bg-lavender/20 text-lavender'}
          `} aria-label={isListening ? 'Listening...' : 'Ask your question'} data-id="element-383">
          <Mic className="w-8 h-8" data-id="element-384" />
        </button>
      </div>
      {isListening && <p className="text-center mt-3 text-gray-600 dark:text-gray-400" data-id="element-385">
          I'm listening... Ask your question
        </p>}
    </div>;
};
export default Help;